<template>
  <path
    d="M21 2.00018H3C1.9 2.00018 1 2.90018 1 4.00018V16.0002C1 17.1002 1.9 18.0002 3 18.0002H10L8.37 20.4502C7.93 21.1102 8.4 22.0002 9.2 22.0002H14.8C15.6 22.0002 16.08 21.1102 15.63 20.4502L14 18.0002H21C22.1 18.0002 23 17.1002 23 16.0002V4.00018C23 2.90018 22.1 2.00018 21 2.00018ZM21 14.0002H3V5.00018C3 4.45018 3.45 4.00018 4 4.00018H20C20.55 4.00018 21 4.45018 21 5.00018V14.0002Z"
  />
</template>
